/**
 * UPS Efficiency equation
 * src: https://schneider.atlassian.net/wiki/spaces/PESV3/pages/2245593414/APC+Efficiency+graph+and+chart BR2
 */
export const efficiency = ({
  curveSquareLoss,
  curveProportionalLoss,
  curveFixedLoss,
}) => (i: number): number => {
  const x = i / 100;
  return (
    (x
      / (x
        + curveSquareLoss * x ** 2
        + curveProportionalLoss * x
        + curveFixedLoss))
    * 100
  );
};
